import { Box, Paper } from '@material-ui/core';
import React from 'react';

const PayTest = () => {
  const [payUrl, setPayUrl] = React.useState(
    'https://ccore.newebpay.com/MPG/mpg_gateway',
  );
  const [merchantID, setMerchantID] = React.useState('MS355976530');
  const [tradeInfo, setTradeInfo] = React.useState('');
  const [tradeSha, setTradeSha] = React.useState('');
  const [version, setVersion] = React.useState('2.2');

  return (
    <div>
      <h1>Pay Test Page</h1>
      <p>測試藍新交易</p>

      <Box component={Paper} square elevation={2} p={1} mt={3} mb={3}>
        <form
          action={payUrl}
          method="POST"
          target="_blank"
          onSubmit={(e) => {
            if (!payUrl) e.preventDefault();
          }}>
          <div>
            <label style={{ lineHeight: '30px', marginTop: '12px' }}>
              PayUrl:
              <input
                type="text"
                name="PayUrl"
                value={payUrl}
                onChange={(e) => setPayUrl(e.target.value)}
                style={{ width: '100%', height: '40px', padding: '0 12px' }}
                required
              />
            </label>
          </div>
          <div>
            <label style={{ lineHeight: '30px', marginTop: '12px' }}>
              MerchantID:
              <input
                type="text"
                name="MerchantID"
                value={merchantID}
                onChange={(e) => setMerchantID(e.target.value)}
                style={{ width: '100%', height: '40px', padding: '0 12px' }}
                required
              />
            </label>
          </div>
          <div>
            <label style={{ lineHeight: '30px', marginTop: '12px' }}>
              TradeInfo:
              <input
                type="text"
                name="TradeInfo"
                value={tradeInfo}
                onChange={(e) => setTradeInfo(e.target.value)}
                style={{ width: '100%', height: '40px', padding: '0 12px' }}
                required
              />
            </label>
          </div>
          <div>
            <label style={{ lineHeight: '30px', marginTop: '12px' }}>
              TradeSha:
              <input
                type="text"
                name="TradeSha"
                value={tradeSha}
                onChange={(e) => setTradeSha(e.target.value)}
                style={{ width: '100%', height: '40px', padding: '0 12px' }}
                required
              />
            </label>
          </div>
          <div>
            <label style={{ lineHeight: '30px', marginTop: '12px' }}>
              Version:
              <input
                type="text"
                name="Version"
                value={version}
                onChange={(e) => setVersion(e.target.value)}
                style={{ width: '100%', height: '40px', padding: '0 12px' }}
                required
              />
            </label>
          </div>
          <Box mt={2}>
            <button type="submit">測試</button>
          </Box>
        </form>
      </Box>
    </div>
  );
};

export default PayTest;
